<template>
    <div id="apiDocument">
        <!--内容区-->
        <div class="contentWrap">
            <div class="contentBox">
                <div class="navList">
                    <div class="apiT">API文档</div>
                    <div class="firstNav" v-for="(item,index) in navData" :key="index"
                         @click="showSecond(item)">
                        {{item.name}}
                        <div class="secondWrap" v-show="item.flag">
                            <div class="secondNav" v-for="(val,idx) in item.childrenData" :key="idx">
                                {{val.name}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contentVal">
                    <div class="contentValTitle">API技术文档</div>
                    <div class="TitleVal">
                        <p>感谢您使用META大数据产品开发文档，此文档为用户提供了一整套简单而又强大的开发工具，旨在帮助用户快速、高效地将Meta大数据产品整合到自己的应用当中。：</p>
                        <p>此文档目前为Beta版，会继续更新</p>
                        <p>如果以下内容没有解决您的问题，请您查看<span @click="toPage('/FAQ')" style="cursor: pointer">常见问题</span>文档</p>
                        <br>

                    </div>
                    <div class="conBox">
                        <div class="firstT">API简介</div>
                        <div class="secondT">接口调用方式说明</div>
                        <h4>REST API</h4>
                        <p>REST，即Representational State Transfer的缩写，是目前最流行的一种互联网软件架构。它结构清晰、符合标准、易于理解、扩展方便，正得到越来越多网站的采用。其优点如下：</p>
                        <ul>
                            <li>在RESTful架构中，每一个URL代表一种资源；</li>
                            <li>客户端和服务器之间，传递这种资源的某种表现层；</li>
                            <li>客户端通过四个HTTP指令，对服务器端资源进行操作，实现“表现层状态转化”。</li>
                        </ul>
                        <div class="secondT">请求费用</div>
                        <p>API接口按调用次数计费，可在产品中心 -> 具体产品页面查询产品API单次调用价格</p>

                        <div class="thirdT">调用限频</div>
                        <p>针对每个ID，META大数据API限制调用次数为20次/秒</p>

                        <div class="fourthT">服务器</div>
                        <p>META的数据库和服务器运行在深圳。为了最大限度地减少API访问延迟，建议您使用与深圳阿里云机房通讯通畅的服务器。</p>


                        <div class="fourthT">请求</div>
                        <div class="fifthT">常见状态码及错误码</div>
                        <ul>
                            <li>200 请求成功</li>
                            <li>400 错误的请求格式</li>
                            <li>401 授权错误</li>
                            <li>403 禁止访问</li>
                            <li>404 地址未找到</li>
                            <li>500 服务器错误</li>
                        </ul>

                        <div class="sixthT">API鉴权验证</div>
                        过程随后补充

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "apiDocument",
        data() {
            return {
                proIndex: 1,
                navData: [
                    {
                        name: "",
                        flag: false,
                        childrenData: [
                            {name: "二级标题1"}, {name: "二级标题2"}, {name: "二级标题3"}
                        ]
                    },
                    {
                        name: "API简介",
                        flag: false,
                        childrenData: [
                            {name: "二级标题1"}, {name: "二级标题2"}, {name: "二级标题3"}
                        ]
                    },
                    {
                        name: "一级标题",
                        flag: false,
                    },
                    {
                        name: "一级标题",
                        flag: false,
                    },
                    {
                        name: "一级标题",
                        flag: false,
                    }
                ]
            }
        },
        mounted() {
            /*淡入淡出效果*/
            window.addEventListener('scroll', this.scrollFun);
            this.scrollFun();
        },
        methods: {
            toPage(page) {
                this.$router.push({path: page});
            },
            showSecond(item) {
                item.flag = !item.flag;
            },
            scrollFun() {
                this.$animate(document.getElementById("apiDocument"), "fadeInUp");
            }
        },
        beforeDestroy() {
            /*销毁监听*/
            window.removeEventListener('scroll', this.scrollFun);
        }
    }
</script>

<style lang="scss" scoped>
    #apiDocument {
        .bannerWrap {
            height: 298px;
            background: url("../../assets/img/FAQ/bg.png");
            background-size: cover;
            background-position: center;
        }
        .contentWrap {
            .contentBox {
                display: flex;
                .navList {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    width: 307px;
                    min-height: 100vh;
                    padding-top: 51px;
                    background: rgba(198, 213, 231, .1);
                    .apiT {
                        margin-bottom: 12px;
                        font-size: 24px;
                        color: #1E2B4D;
                    }
                    .firstNav {
                        margin-bottom: 20px;
                        font-size: 24px;
                        line-height: 33px;
                        cursor: pointer;
                        color: #1E2B4D;
                        .secondWrap {
                            .secondNav {
                                margin-top: 8px;
                                font-size: 16px;
                                color: #1E2B4D;
                            }
                        }
                    }
                }
                .contentVal {
                    width: 1200px;
                    padding-top: 55px;
                    margin-left: 51px;
                    .contentValTitle {
                        margin-bottom: 10px;
                        font-size: 40px;
                        color: #152346;
                        text-align: justify;
                    }
                    .TitleVal {
                        margin-bottom: 36px;
                        p {
                            margin-bottom: 10px;
                        }
                    }
                    p {
                        opacity: 0.8;
                        font-size: 16px;
                        color: #152346;
                        line-height: 24px;
                        span {
                            color: #4d65e7;
                        }
                    }
                    .conBox {
                        margin-bottom: 64px;
                        .firstT {
                            margin-bottom: 12px;
                            font-size: 30px;
                            color: #152346;
                            text-align: justify;
                        }
                        .secondT {
                            margin-bottom: 12px;
                            font-size: 20px;
                            color: #152346;
                            text-align: justify;
                        }
                        p {
                            margin-bottom: 30px;
                        }
                    }
                }
            }
        }
    }
</style>